<div class="panel-body no-padding" id="topoAlterar">
  <h3 class="text-light-blue" style="margin-top: 10px;">
    <b>Avaliar alteração no plano de trabalho</b>
  </h3>
</div>

<div class="panel-body no-padding">
  <div class="col-md-12">
    <hr>

    <ul class="timeline">

      <li class="time-label" id="etapa01">
        <span class="bg-red">Etapa 1</span>
      </li>
      <li>
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">
          <h3 class="timeline-header">
            <a (click)="openEtapa1()" style="cursor: pointer;">1 - DESCRIÇÃO DA REALIDADE</a>
          </h3>

          <router-outlet *ngIf="etapa1"></router-outlet>

        </div>
      </li>

      <li class="time-label" id="etapa02">
        <span class="bg-red">Etapa 2</span>
      </li>
      <li>
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa2()" style="cursor: pointer;">2 – SÍNTESE DA PROPOSTA</a>
          </h3>

          <router-outlet *ngIf="etapa2"></router-outlet>

        </div>
      </li>

      <li class="time-label" id="etapa03">
        <span class="bg-red">Etapa 3</span>
      </li>
      <li>
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa3()" style="cursor: pointer;">3 – CAPACIDADE INSTALADA</a>
          </h3>

          <router-outlet *ngIf="etapa3"></router-outlet>

        </div>
      </li>

      <li class="time-label" id="etapa04">
        <span class="bg-red">Etapa 4</span>
      </li>
      <li>
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa4()" style="cursor: pointer;">4 – MONITORAMENTO, AVALIAÇÃO E SUSTENTABILIDADE DA
              PROPOSTA</a>
          </h3>

          <router-outlet *ngIf="etapa4"></router-outlet>

        </div>
      </li>

      <li class="time-label" id="etapa05">
        <span class="bg-red">Etapa 5</span>
      </li>
      <li>
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">


          <h3 class="timeline-header">
            <a (click)="openEtapa5()" style="cursor: pointer;">5 – CRONOGRAMA FÍSICO DE EXECUÇÃO DO OBJETO</a>
          </h3>
          <router-outlet *ngIf="etapa5"></router-outlet>
        </div>
      </li>

      <li class="time-label" id="etapa06">
        <span class="bg-red">Etapa 6</span>
      </li>
      <li>
        <i class="fa fa-clone bg-blue"></i>
        <div class="timeline-item">

          <h3 class="timeline-header">
            <a (click)="openEtapa6()" style="cursor: pointer;">6 – DETALHAMENTO (Memória de Cálculo) DA APLICAÇÃO DOS
              RECURSOS FINANCEIROS</a>
          </h3>
          <router-outlet *ngIf="etapa6"></router-outlet>
        </div>
      </li>



    </ul>

  </div>

</div>